const API_URL = process.env.REACT_APP_API_URL;

export const fetchPublicEventTypes = async () => {
  const response = await fetch(`${API_URL}/eventTypes/public`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
    },
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || 'Failed to fetch public events');
  }
  return response.json();
};

export const submitGuestRegistration = async (payload) => {
  const response = await fetch(`${API_URL}/guestRegistration`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || 'Guest registration failed');
  }
  return response.json();
};
